import { getPortalId } from './getPortalId';
export const getRootUrl = () => {
  const portalId = getPortalId() || '';
  return `/notifications/${portalId}`;
};
export const HUBLESS_ROOT_URL = '/notifications/hubless';